<div
  class="forms-library-container d-flex flex-column h-100 z-index-3 position-fixed white-background"
  cssTransitionEnd
  (transitionEnded)="formLibraryOpen($event)"
  [ngClass]="{ 'w-0': !initialized, 'w-100': initialized }"
>
  <div class="forms-library-links" kendoTooltip tooltipClass="em-tooltip" position="top">
    <div class="re-links">
      <button (click)="closeFormLibrary()" class="btn em-btn close-panel">
        <i class="far fa-times" title="Close Panel"></i>
      </button>
    </div>
  </div>

  <div class="forms-library-header row m-0 grey-three-background" kendoTooltip tooltipClass="em-tooltip" position="top">
    <ng-container>
      <div class="title-row d-flex text-nowrap pl-3 py-1">
        <h6><i class="far fa-folder-open"></i>&nbsp;&nbsp;eFORM TEMPLATE LIBRARY</h6>
      </div>
    </ng-container>
  </div>

  <!-- Nav Tabs -->
  <nav class="forms-library-tabs tabs-no-pagination" mat-tab-nav-bar>
    <a
      *ngFor="let formTypeName of formTypeNames | keyvalue"
      mat-tab-link
      [active]="activeTab === formTypeName.key"
      style="border-left: none"
      (click)="selectTab(formTypeName.key)"
    >
      {{ formTypeName.value }}</a
    >
  </nav>

  <div class="content row" kendoTooltip tooltipClass="em-tooltip" position="top">
    <!-- Left Column - Grid -->
    <div class="col-3 h-100">
      <ngx-loading [show]="disableGrid" id="gridDisableDiv"></ngx-loading>
      <kendo-grid
        [data]="gridView"
        [pageSize]="gridState.take"
        [skip]="gridState.skip"
        [sort]="gridState.sort"
        [sortable]="true"
        [selectable]="true"
        [style.height.%]="100"
        (selectionChange)="onSelectRow($event)"
        kendoGridSelectBy="id"
        [selectedKeys]="selectedKeys"
      >
        <kendo-grid-column field="name" title="Name" [headerClass]="'teal-background white-font'">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.name }}
            <div *ngIf="dataItem.notes && dataItem.notes !== ''">
              <span> (<strong>Notes:</strong>{{ dataItem.notes }}) </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridDetailTemplate let-dataItem>
          <section>
            <div>
              <strong>Shared by User:</strong>
              {{
                dataItem.sharedByUser
                  ? dataItem.sharedByUser.firstName + ' ' + dataItem.sharedByUser.lastName
                  : 'Anonymous'
              }}
            </div>
            <div>
              <strong>Shared by Clinic:</strong>
              {{ dataItem.sharedByClinic ? dataItem.sharedByClinic.name : 'Anonymous' }}
            </div>
            <div><strong>Shared Date:</strong> {{ dataItem.createdDate | date : 'yyyy-MM-dd' }}</div>
          </section>
        </ng-template>
        <kendo-grid-command-column
          title="Actions"
          [headerClass]="'teal-background white-font'"
          [width]="isDeveloper ? 134 : 50"
        >
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <div class="d-flex">
              <button
                *ngIf="isDeveloper"
                class="btn kendo-btn k-button"
                (click)="editMetadataHandler(dataItem)"
                kendoTooltip
                tooltipClass="em-tooltip"
                position="top"
                title="Edit Form Details"
              >
                <i class="fas fa-pencil"></i>
              </button>
              <button
                *ngIf="isDeveloper"
                class="btn kendo-btn k-button"
                (click)="editFormHandler(dataItem, $event)"
                kendoTooltip
                tooltipClass="em-tooltip"
                position="top"
                title="Edit Form"
              >
                <i class="far fa-edit"></i>
              </button>
              <button
                *ngIf="isDeveloper"
                class="btn kendo-btn k-button"
                (click)="deleteFormHandler(dataItem)"
                kendoTooltip
                tooltipClass="em-tooltip"
                position="top"
                title="Delete Form"
              >
                <i class="fas fa-minus-circle"></i>
              </button>
              <button
                class="k-button"
                (click)="addFromLibraryHandler(dataItem.id)"
                kendoTooltip
                tooltipClass="em-tooltip"
                position="top"
                title="Add From Template Library"
              >
                <i class="far fa-cloud-download-alt"></i>
              </button>
            </div>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>
    <!-- Right Column - Viewer/Editor -->
    <div class="col-9 h-100">
      <div *ngIf="editMode && isDeveloper" class="d-flex py-2">
        <button type="button" class="btn em-btn em-btn-green flex-nowrap ml-auto mr-1" (click)="saveHandler()">
          <i class="fal fa-save"></i>
          &nbsp;Save
        </button>
        <button type="button" class="btn em-btn em-btn-green flex-nowrap" (click)="cancelHandler()">
          <i class="fal fa-ban"></i>
          &nbsp;Cancel
        </button>
      </div>
      <ng-container *ngIf="selectedForm">
        <ng-scrollbar class="h-100">
          <app-form-builder *ngIf="editMode" [form]="editingForm" [refreshBuilder]="formRefreshed$"></app-form-builder>
          <div *ngIf="!editMode" class="card card-outer">
            <div class="card-body">
              <div class="card bg-light">
                <app-form-viewer
                  [form]="selectedForm"
                  [editable]="false"
                  [refreshViewer]="formRefreshed$"
                ></app-form-viewer>
              </div>
            </div>
          </div>
        </ng-scrollbar>
      </ng-container>
      <ng-container *ngIf="!selectedForm">
        <div class="h-100 w-100 d-flex align-items-start justify-content-center px-0">
          <span class="m-auto font-weight-bold" style="font-size: 2em">Please select a form.</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
